import { DataService } from '../../../services/data_service';
import { getGTZHochrechnung } from '../dialogs/getGTZHochrechnung';
import { getGTZinRange } from '../dialogs/getHochrechnung';
import { IDs } from '../../../helpers/IDs';
import * as Moment from 'moment';

export function getWitterungsFaktor(data_service: DataService, ort: any, callback: (wdata: any) => void): void {
    // const gtz_hochrechnung = getGTZHochrechnung(valuesGtz, data);
    data_service.loadDataForModul(
        IDs.ENT_GTZ, { ort_tid: ort.tid }, {}, IDs.MOD_ETOOL_ADMIN,
        (res: any) => {
            const wdata: any = {};
            const gtz_base = res[IDs.ENT_GTZ];
            const jahrMax = Moment().year() - 1;
            const jahrMin = 2010;
            const gtz_hochrechnung = getGTZHochrechnung(gtz_base);

            for (let i = jahrMin; i <= jahrMax ; i++) {
                const from = new Date(`${i}-01-01`);
                const to = new Date(`${i}-12-31`);
                const gtz_year = getGTZinRange(from.getTime() / 1000, to.getTime() / 1000, gtz_hochrechnung);
                // GTZ -> Langjähriges Mittel
                /*if (i === jahrMin) {
                    wdata[i] = { gtz: gtz_year.sumGTZ, wfaktor: 1 };
                } else {
                    const faktor = wdata[jahrMin].gtz / gtz_year.sumGTZ;
                    wdata[i] = { gtz: gtz_year.sumGTZ, wfaktor: faktor };
                }*/
                const faktor = gtz_year.sumGTZ > 0 ? gtz_year.sumMittel / gtz_year.sumGTZ : 1;
                wdata[i] = { gtz: gtz_year.sumGTZ, wfaktor: faktor };
            }
            // console.log('W-Faktor', wdata);
            callback(wdata);
        }
    );
}
